
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class Adv05ItemExDTsGrid extends Serenity.EntityGrid<Adv05ItemExDTsRow, any> {
        protected getColumnsKey() { return Adv05ItemExDTsColumns.columnsKey; }
        protected getDialogType() { return Adv05ItemExDTsDialog; }
        protected getIdProperty() { return Adv05ItemExDTsRow.idProperty; }
        protected getInsertPermission() { return Adv05ItemExDTsRow.insertPermission; }
        protected getLocalTextPrefix() { return Adv05ItemExDTsRow.localTextPrefix; }
        protected getService() { return Adv05ItemExDTsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}